import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import './App.css';

interface NavigationBarProps {
    loggedIn: boolean;
}

function NavigationBar(props: NavigationBarProps) {

    const items = props.loggedIn ?
        (<Nav className="me-auto">
            <Nav.Link href="/setup">Setup</Nav.Link>
            <Nav.Link href="/generate">Generate</Nav.Link>
            <Nav.Link href="/logout">Logout</Nav.Link>
        </Nav>) :
        (<Nav className="me-auto">
            <Nav.Link href="/login">Login</Nav.Link>
        </Nav>);


    return (
        <Navbar expand="lg" className="navbar navbar-expand-lg navbar-dark bg-dark">
            <Container className="px5">
                <Navbar.Brand href="/">GenPost</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    {items}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavigationBar;